module.exports = __webpack_public_path__ + "img/detail-right-floor.597ef45a.png";